import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { sdk } from '@/services/sdk';
import { PageHeader } from '@/components/kit';
import { BackLink } from '@/components/record';
import ReviewForm, { blankReview } from '@/components/admin/ReviewForm';
import { committed } from '@/shared/data';

export const route = { path: '/admin/reviews/new', layout: 'owner', access: "['Admin_c','Staff_c'].includes(profile)" };

export default function NewReview() {
  const navigate = useNavigate();
  const [initial] = useState(blankReview);
  const [saving, setSaving] = useState(false);

  async function create(payload) {
    setSaving(true);
    try {
      const res = await sdk.table('reviews_c').create(payload);
      const saved = committed(res, 'Review added');
      if (!saved) return;
      navigate(saved.Id ? `/admin/reviews/${saved.Id}` : '/admin/reviews');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="mx-auto max-w-5xl">
      <BackLink to="/admin/reviews" label="Back to Reviews" />
      <PageHeader
        eyebrow="Reviews"
        title="Add a review"
        description="For feedback a customer sent by DM and agreed to share."
      />
      <ReviewForm initial={initial} onSubmit={create} saving={saving} submitLabel="Add review" busyLabel="Adding…" cancelTo="/admin/reviews" />
    </div>
  );
}
